
import $ from 'jquery';
import './jquery.anythingslider.js';

import * as themes from './themes';

export default function(selector, theme, options = {}) {
  themes[theme.replace(/-/, '')].use();

  options = $.extend({ theme: theme }, options);
  $(selector).anythingSlider(options);
}



// WEBPACK FOOTER //
// ./src/frontend/slider-v1/index.js